export const FNCH_COMPETITOR_ID = 'fnch-competitor-id';
export const FNCH_COMPETITION_ID = 'fnch-competition-id';
